import { createOkrPeriodName } from '../../../utils/common';

const DisplayFiscalTimeFrames = ({goal, user}) => {
  const { okrPeriodType, okrPeriod } = goal;
  if (okrPeriodType == 3) {
    return okrPeriod;
  }
  else {
    // Check if the period name starts with T (trimester) or H (half-year)
    // If so, return it as-is instead of converting to FY
    if (okrPeriod && /^(T[1-3]|H[1-2])\s/.test(okrPeriod)) {
      return okrPeriod;
    }
    const splitText = okrPeriod.split(' ');
    if (splitText.length > 2) {
      return createOkrPeriodName(splitText[3], splitText[4], okrPeriodType);
    }
    return createOkrPeriodName(splitText[0], splitText[1], okrPeriodType);
  }
}

export default DisplayFiscalTimeFrames;